var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSegurancaCor({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_1825)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 9.16671C10 7.91671 20 3.33337 20 3.33337V35C20 35 5 31.6667 5 9.16671Z",
    fill: "#CD992B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 9.16671C30 7.91671 20 3.33337 20 3.33337V35C20 35 35 31.6667 35 9.16671Z",
    fill: "#A65718"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 10.8333C10 9.58333 20 5 20 5V36.6667C20 36.6667 5 33.3333 5 10.8333Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 10.8333C30 9.58333 20 5 20 5V36.6667C20 36.6667 35 33.3333 35 10.8333Z",
    fill: "#FFC20E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5833 18.0625V16.5417C24.5833 15.3261 24.1004 14.1603 23.2409 13.3008C22.3814 12.4413 21.2156 11.9584 20 11.9584C18.7844 11.9584 17.6186 12.4413 16.7591 13.3008C15.8996 14.1603 15.4167 15.3261 15.4167 16.5417V18.0625C14.9299 18.235 14.5084 18.5538 14.21 18.9753C13.9116 19.3968 13.7509 19.9003 13.75 20.4167V25.8334C13.7507 26.4962 14.0144 27.1317 14.483 27.6003C14.9517 28.069 15.5872 28.3326 16.25 28.3334H23.75C24.4128 28.3326 25.0483 28.069 25.517 27.6003C25.9856 27.1317 26.2493 26.4962 26.25 25.8334V20.4167C26.2491 19.9003 26.0884 19.3968 25.79 18.9753C25.4916 18.5538 25.0701 18.235 24.5833 18.0625ZM20 13.625C20.7733 13.626 21.5146 13.9336 22.0614 14.4803C22.6081 15.0271 22.9157 15.7684 22.9167 16.5417V17.9167H17.0833V16.5417C17.0843 15.7684 17.3919 15.0271 17.9386 14.4803C18.4854 13.9336 19.2267 13.626 20 13.625ZM24.5833 25.8334C24.5831 26.0543 24.4952 26.2662 24.339 26.4224C24.1828 26.5786 23.9709 26.6665 23.75 26.6667H16.25C16.029 26.6666 15.8172 26.5787 15.6609 26.4225C15.5047 26.2662 15.4168 26.0543 15.4167 25.8334V20.4167C15.4169 20.1958 15.5048 19.9839 15.661 19.8277C15.8172 19.6715 16.0291 19.5836 16.25 19.5834H23.75C23.9709 19.5837 24.1827 19.6716 24.3389 19.8278C24.4951 19.984 24.583 20.1958 24.5833 20.4167V25.8334Z",
    fill: "#00416B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 21.3086C19.7633 21.3082 19.5318 21.3785 19.3353 21.5104C19.1387 21.6422 18.9859 21.8297 18.8964 22.0489C18.807 22.2681 18.7849 22.5089 18.833 22.7407C18.8812 22.9725 18.9973 23.1846 19.1667 23.35V24.1614C19.1667 24.3824 19.2545 24.5944 19.4107 24.7506C19.567 24.9069 19.779 24.9947 20 24.9947C20.221 24.9947 20.433 24.9069 20.5893 24.7506C20.7455 24.5944 20.8333 24.3824 20.8333 24.1614V23.35C21.0025 23.1846 21.1186 22.9724 21.1666 22.7407C21.2147 22.509 21.1926 22.2682 21.1031 22.0491C21.0137 21.83 20.861 21.6425 20.6645 21.5106C20.468 21.3787 20.2367 21.3084 20 21.3086Z",
    fill: "#0083CA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_1825"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSegurancaCor);
export default __webpack_public_path__ + "static/media/seguranca-cor.1ead23686758cce3cbab76d27fa4526a.svg";
export { ForwardRef as ReactComponent };